import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-752f63e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "UIShard grid *:row-start-1 *:col-start-1" };
const _hoisted_2 = { class: "Shard relative" };
const _hoisted_3 = { class: "Shard__Inner size-full" };
const _hoisted_4 = {
    key: 0,
    class: "Shard__Edge absolute inset-0"
};
const _hoisted_5 = ["width", "height", "viewBox"];
const _hoisted_6 = ["id", "d"];
const _hoisted_7 = ["href", "stroke", "stroke-width"];
const _hoisted_8 = ["id"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["id"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("rect", {
    fill: "white",
    width: "100%",
    height: "100%"
}, null, -1));
const _hoisted_12 = ["href"];
const _hoisted_13 = ["id"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("stop", { "stop-color": "white" }, null, -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("stop", {
    offset: "1",
    "stop-color": "white",
    "stop-opacity": "0"
}, null, -1));
const _hoisted_16 = [
    _hoisted_14,
    _hoisted_15
];
import { computed, getCurrentInstance } from "vue";
import Viewport from "@/store/modules/Viewport";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIShard',
    props: {
        variant: { default: 0 }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "3c4c4f09": (clipPathSource),
            "374323f0": (shard.value.blur),
            "e06aa32e": (shard.value.shadow),
            "31cf49a0": (maskSource)
        }));
        const props = __props;
        const shards = [
            {
                width: 250,
                height: 324,
                path: "M109.765 7.2169C119.944 9.30469 127.865 6.60888 130.553 5L242.099 262.357L248.278 315.469L238.219 322.832L208.65 304.69L201.581 303.24L199.915 297.007L190.018 294.977L122.73 258.199C108.854 174.287 36.8484 116.865 2.58036 98.6424L1 97.7291L3.1183 93.1559L4.15604 89.5393L109.765 7.2169Z",
                strokeWidth: 0.958381,
                gradient: { x1: "117.638", y1: "-1.26354", x2: "166.319", y2: "321.904" },
                shadow: "0.958px -3.834px 0px #FFF",
                blur: "7.67px",
            },
            {
                width: 267,
                height: 293,
                path: "M184.698 9.36064L174.066 3L1 219.105L48.0851 227.734L101.522 241.938L227.252 292.188L265.301 108.699L243.522 90.7361L244.957 82.9098L229.414 55.059L208.364 21.0512L209.667 13.9364L184.698 9.36064Z",
                strokeWidth: 0.586713,
                gradient: { x1: "249.409", y1: "219.689", x2: "22.7215", y2: "165.091" },
                shadow: "0.587px -2.347px 0px #FFF",
                blur: "4.69px",
            },
            {
                width: 290,
                height: 316,
                path: "M31.2115 51.4406L1 44.6045L127.388 301.706L253.805 278.035C255.315 272.053 257.78 257.827 255.559 248.775C252.782 237.459 261.016 176.082 263.281 167.11C265.546 158.137 271.304 153.772 263.843 142.018C257.874 132.615 145.914 90.456 90.6804 70.5518L72.8172 59.4309L63.9236 61.0962L31.2115 51.4406Z",
                strokeWidth: 0.35482,
                gradient: { x1: "280.425", y1: "196.128", x2: "47.0243", y2: "226.571" },
                shadow: "1.06px -0.71px 0px rgba(255, 255, 255, 0.68)",
                blur: "2.84px",
            },
            {
                width: 303,
                height: 388,
                path: "M1 175.794C10.3955 199.027 204.91 325.607 300.993 385.994L232.439 17.5381C176.604 12.0774 63.5004 2.08714 57.7728 5.81204C50.6132 10.4681 35.5764 94.2151 33.1285 105.18C31.1702 113.953 10.8935 155.911 1 175.794Z",
                strokeWidth: 1.10734,
                gradient: { x1: "0.366925", y1: "99.9967", x2: "302.542", y2: "136.789" },
                shadow: "1.107px -4.429px 0px rgba(255, 255, 255, 0.80)",
                blur: "8.86px",
            },
        ];
        const { uid } = getCurrentInstance();
        const clipPathSource = `url(#clipPath-${uid})`;
        const maskSource = `url(#mask-${uid})`;
        const shard = computed(() => shards[props.variant]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    (!_unref(Viewport).isSafari)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                        : _createCommentVNode("", true)
                ]),
                (_openBlock(), _createElementBlock("svg", {
                    class: "relative",
                    width: shard.value.width,
                    height: shard.value.height,
                    viewBox: `0 0 ${shard.value.width} ${shard.value.height}`,
                    fill: "none"
                }, [
                    _createElementVNode("path", {
                        id: `path-${_unref(uid)}`,
                        d: shard.value.path
                    }, null, 8, _hoisted_6),
                    _createElementVNode("use", {
                        href: `#path-${_unref(uid)}`,
                        stroke: `url(#gradient-${_unref(uid)})`,
                        "stroke-width": shard.value.strokeWidth
                    }, null, 8, _hoisted_7),
                    _createElementVNode("clipPath", {
                        id: `clipPath-${_unref(uid)}`
                    }, [
                        _createElementVNode("use", {
                            href: `#path-${_unref(uid)}`
                        }, null, 8, _hoisted_9)
                    ], 8, _hoisted_8),
                    _createElementVNode("mask", {
                        id: `mask-${_unref(uid)}`
                    }, [
                        _hoisted_11,
                        _createElementVNode("use", {
                            href: `#path-${_unref(uid)}`,
                            fill: "black"
                        }, null, 8, _hoisted_12)
                    ], 8, _hoisted_10),
                    _createElementVNode("defs", null, [
                        _createElementVNode("linearGradient", _mergeProps({
                            id: `gradient-${_unref(uid)}`
                        }, shard.value.gradient, { gradientUnits: "userSpaceOnUse" }), _hoisted_16, 16, _hoisted_13)
                    ])
                ], 8, _hoisted_5))
            ]));
        };
    }
});
